import React, {useState, useEffect} from "react";
import SubBanner from "../../../components/SubBanner";
import bannerImg from "../../../assets/img/resources_banner.png";
import { BOARD_LIST_URL, BOARD_DETAIL_URL } from "../../../utils/urls";
import instance from "../../../services/services";

function Faq(){
   // 0: Notice, 1: FAQ, 2: 자료실, 3:Blog
  const [activeTab, setActiveTab] = useState(1);
  const [faqData, setFaqData] = useState([[], []]); // [광고주 데이터, 매체 데이터]
  const [searchText, setSearchText] = useState('');
  const [faqDetails, setFaqDetails] = useState({}); // FAQ 상세 내용 저장
  
  // 배너 탭
  const tabList = [
    { label : 'Notice', url : '/resources/notice'},
    { label : 'FAQ', url : '/resources/faq'},
    { label : '자료실', url : '/resources/data'},
    { label : 'Blog', url : '/resources/blog'},
  ]

  // faq탭
  const fasTabList = [
    { label: "광고주", category: "advertiser" },
    { label: "매체", category: "media" },
  ];

  // FAQ 데이터 가져오기
  const fetchFaqData = async (category, search = '') => {
    try{
      const response = await instance.post(BOARD_LIST_URL, {
        boardid: "faq",
        offset: 1,
        searchText: search, 
        category: category // advertiser 또는 media
      });
      return response.data.data.data || [];
    } catch (error) {
      console.error('FAQ 데이터 가져오기 오류:', error);
      return [];
    }
  };

  // FAQ 상세 내용 가져오기
  const fetchFaqDetail = async (b_seq) => {
    try {
      const response = await instance.post(BOARD_DETAIL_URL, {
        boardid: "faq",
        b_seq: b_seq
      });
      return response.data.data;
    } catch (error) {
      console.error('FAQ 상세 데이터 가져오기 오류:', error);
      return null;
    }
  };

  // 초기 데이터 로드 - 광고주 탭만 먼저 로드
  useEffect(() => {
    const loadInitialData = async () => {
      const advertiserData = await fetchFaqData('advertiser');
      setFaqData([advertiserData, []]);
    };
    loadInitialData();
  }, []);

  // 탭 변경 시 해당 카테고리 데이터 다시 가져오기
  const handleTabChange = async (idx) => {
    setTab(idx);
    setOpenIdx(null); // 탭 변경 시 열려있는 답변FAQ 닫기
    
    // 해당 탭의 데이터가 없으면 가져오기
    if (faqData[idx].length === 0) {
      const category = fasTabList[idx].category;
      const data = await fetchFaqData(category, searchText);
      
      const newFaqData = [...faqData];
      newFaqData[idx] = data;
      setFaqData(newFaqData);
    }
  };

  // 검색 핸들러
  const handleSearch = async () => {
    const category = fasTabList[isTab].category;
    const data = await fetchFaqData(category, searchText);
    
    const newFaqData = [...faqData];
    newFaqData[isTab] = data;
    setFaqData(newFaqData);
  };

  // 검색어 삭제 핸들러
  const handleClearSearch = async () => {
    setSearchText('');
    const category = fasTabList[isTab].category;
    const data = await fetchFaqData(category, '');
    
    const newFaqData = [...faqData];
    newFaqData[isTab] = data;
    setFaqData(newFaqData);
  };

  const [isTab, setTab] = useState(0); // faq탭
  const faqList = faqData[isTab];   // faq탭 내용물
  const [openIdx, setOpenIdx] = useState(null); //faq답변

  // FAQ 항목 클릭 핸들러
  const handleFaqClick = async (idx, b_seq) => {
    if (openIdx === idx) {
      // 이미 열려있는 항목을 클릭하면 닫기
      setOpenIdx(null);
    } else {
      // 새로운 항목을 클릭하면 상세 내용 가져오기
      setOpenIdx(idx);
      
      // 이미 가져온 상세 내용이 있는지 확인
      if (!faqDetails[b_seq]) {
        const detailData = await fetchFaqDetail(b_seq);
        if (detailData) {
          setFaqDetails(prev => ({
            ...prev,
            [b_seq]: detailData
          }));
        }
      }
    }
  };

  return(
    <div className="resources">
    {/* 배너 */}
      <SubBanner
        bgImg={bannerImg}
        title= {'FAQ'}
        tabs={tabList.map((tab,idx) => ({
          label : tab.label,
          url : tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "Resources", url: "/resources" },
          { label: "FAQ", url: "/resources/faq", active: true }
        ]}
      />

      <section className="sub_section mt-[180px] md:mt-[210px] mb-[120px] mx-auto">
          {/* 검색창 */}
          <div className="flex items-center justify-end">
            <div className="srch_box">
              <label htmlFor="form_search" className="blind">검색어 입력</label>
              <input 
                type="text" 
                id="form_search" 
                placeholder="키워드를 검색해 보세요" 
                className="focus:border-[#F84343] focus:outline-none"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearch();
                  }
                }}
              />
              <button 
                type="button" 
                className="absolute right-[55px] top-1/2 -translate-y-1/2"
                onClick={handleClearSearch}
              >
                <i className="icon icon_delete">검색어 삭제</i>
              </button>
              <button 
                type="button" 
                className="absolute right-[15px] top-1/2 -translate-y-1/2"
                onClick={handleSearch}
              >
                <i className="icon icon_srch">검색하기</i>
              </button> 
            </div>
          </div>

          {/* faq */}
          <div className="notice_container w-full mx-auto mt-[40px]">
            {/* 탭 */}
            <div className="flex rounded-[16px] overflow-hidden mb-[40px] bg-[#F4F5F6] ">
              {fasTabList.map((tab, idx) => (
                <button
                  key={tab.label}
                  className={`tab_btn flex-1 md:py-[20px] transition-colors bg-[#F4F5F6] 
                    ${isTab === idx
                      ? "text-[#F84343] font-bold bg-white border-[1px] border-[#F84343] rounded-[16px] " 
                      : "text-[#999]"}
                  `}
                  onClick={() => handleTabChange(idx)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* FAQ 리스트 */}
            <div className="faq_list flex flex-col gap-4">
              {faqList.map((item, idx) => (
                <div
                  key={item.b_seq || idx}
                  className="rounded-[20px] bg-[#F4F5F6]"
                >
                  <button
                    className="w-full bg-white flex items-center justify-between text-left focus:outline-none rounded-[20px]  border-[1px] border-[#E8E8E8]"
                    onClick={() => handleFaqClick(idx, item.b_seq)}
                  >
                    <span className="hidden md:flex items-center text-[#F84343] mr-[32px]">
                      Q{idx + 1}
                    </span>
                    <span className="ellipsis_long flex-1 text-lg text-[#555]">{item.subject}</span>
                    <i className={`icon icon_up transition-transform ${openIdx === idx ? "rotate-180" : ""}`}></i>
                  </button>
                  {/* 답변 */}
                  {openIdx === idx && (
                    <div className="faq_aw animate-fadeIn" dangerouslySetInnerHTML={{ __html: faqDetails[item.b_seq] ? faqDetails[item.b_seq].contents || faqDetails[item.b_seq].sub_title || "답변 내용이 없습니다." : "로딩 중..." }}></div>
                  )}
                </div>
              ))}
            </div>
          </div>

      </section> 

    </div>
  )
};

export default Faq;